import thothV2 from '../api/thothV2';
import BaseFetch from './base';

export default class ThothV2 extends BaseFetch {
    api = thothV2
}
